import { BreadCrumbStyle } from "./style";

export const BreadCrumbComponent = props => (
    <BreadCrumbStyle {...props}>
        {props.children}
    </BreadCrumbStyle>
);